<!--
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：主页面入口
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
-->
<template>
	<div id="app-main" name="app-main" class="app-main">
		<el-header class="app-header-el" :style="{
			padding: '0px', 
			height: '120px', 
			backgroundColor: '#545c64',
			}">
			<myHeader :user-info="userInfo"/>
		</el-header>
		<div class="div-main">
			<el-aside id="mainAside" class="mainAside" :style="'width: ' + setWidth()">
				<myAside :user-info="userInfo"/>
			</el-aside>
			<el-container class="el-container-main">
				<el-header class="main-header-el">
					<myMainHeader :user-info="userInfo"/>
				</el-header>
				<myTags class="myTags" :user-info="userInfo"/>
				<el-main class="el-main">
					<router-view></router-view>
				</el-main>
			</el-container>
		</div>
		<el-footer><myFooter :user-info="userInfo" :screen-width="srcWidth" /></el-footer>
		<component :is="floatBarComponent" v-if="floatBarComponent" />
	</div>
</template>

<script>
// 加载头部区域
import myHeader from '../components/Header.vue'
// 左侧菜单
import myAside from '../components/Aside.vue'
// 头部区域
import myMainHeader from '../components/MainHeader.vue'
// 加载底部区域
import myFooter from '../components/Footer.vue'
// Tags 显示区域
import myTags from '../components/Tags.vue'
// 法律相关声明
//import myLegalNotice from '../components/LegalNotice.vue'

//import { gethttp2https } from '../utils/function.js';
//import { getCurInfo } from '../api';

// 输出元素
export default {
	name: 'app-main',
	data() {
		return {
			// 初始化userInfo为空对象
			// 这种初始化才能有效传递给子组件
			userInfo: this.$utils.getCurInfo() || {},
			// 用于动态组件
			floatBarComponent: null,
			srcWidth: this.getSrcWidth(),
		}
	},
	components: {
		myHeader,
		myAside,
		myMainHeader,
		myTags,
		myFooter,
	},
	methods: {
		get_ifloatbar() {
			return 0;
		},
		getSrcWidth() {
			// 获取屏幕宽度
			const width = window.innerWidth;
			return width;
		},
		// 左侧菜单界面自适应
		setWidth() {
			if(this.srcWidth > 600)
			{
				return "240px";
			}
			else
			{
				return "100%";
			}
		},
		// 根据用户类型导入不同的组件
		/* getFloatBarComponent() { 
			switch(this.userType) { 
				case 1: return import('../components/FloatBar/1.vue'); 
				case 2: return import('../components/FloatBar/2.vue'); 
				case 3: return import('../components/FloatBar/3.vue'); 
				case 4: return import('../components/FloatBar/4.vue'); 
				default: return import('../components/FloatBar/0.vue'); 
			}
		} */
		// 加载浮动工具栏组件
		loadFloatBarComponent() {
			const ifloatbar = this.userInfo.ifloatbar || 'default';
			import(`../components/FloatBar/${ifloatbar}.vue`)
				.then(component => {
					this.floatBarComponent = component.default;
				})
				.catch(error => {
					console.error('加载浮动工具栏组件失败:', error);
					// 加载默认组件作为回退
					import('../components/FloatBar/default.vue')
						.then(component => {
							this.floatBarComponent = component.default;
						});
				});
		},
	},
	mounted() {
		// 加载浮动工具栏组件
		this.loadFloatBarComponent();
	}
}
</script>

<style lang="less" Scoped>
.app-main {
	display: flex;
	flex-direction: column;
	/* height: 100%; */

	.el-header {
		background-color: #B3C0D1;
		color: #333;
		text-align: center;
	}


	.el-footer {
		background-color: #B3C0D1;
		color: #333;
		text-align: center;
		height: auto;
		margin: 0px;
		padding: 0px;
	}

	/*
	.el-header {
		background-color: #B3C0D1;
		color: #333;
		text-align: center;
	}
	*/

	.div-main {
		display: flex; 
		flex: 1;
		min-height: calc(100vh - 180px);
	}

	.el-main {
		background-color: #E9EEF3;
		color: #333;
		text-align: left;
		padding: 10px 10px;
		/* line-height: 160px; */
	}

	/*
	body > .el-container {
		margin-bottom: 40px;
	}*/

	.el-container {
		display: flex;
		flex-direction: column;
	}

	.main-header-el{
		padding: 0px 5px;
	}
	.el-container:nth-child(5) .el-aside,
	.el-container:nth-child(6) .el-aside {
	/* line-height: 260px; */
	}

	.el-container:nth-child(7) .el-aside {
	/* line-height: 320px; */
	}

	.myTags {
		padding: 10px 10px 15px 10px;
		text-align: left;
		display: flex;
		gap: 10px;
	}

	.mainAside {
		background-color: #f8f8f8;
		color: #333;
		text-align: left;
		top: 0px;
		left: 0px;
		width: auto;
		box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
		display: ;
		overflow: hidden;
	} 
	.mainAside.hidden {
		display: none;
		position: ;
	}
	.el-container-main {
		margin: 0px;
		padding: 0px;
	}

	@media (max-width: 600px) {
		.app-header-el {
			display: none;
		}
		.mainAside {
			position: fixed;
			top: 0px;
			left: 0px;
			height: 100vh;
			width: 200px;
			transition: transform 0.4s ease;
			z-index: 99;
			background-color: rgba(0, 0, 0, 0); 
		}
		.el-footer {
			display: none;
		}
		.mainAside.hidden {
			transform: translateX(-100%);
		}
		.main-header-el{
			padding: 0px;
		}
		.header-container {
			margin: 0px;
			height: 100%;
		}
		.el-main {
			padding: 7px;
			margin-bottom: 70px;
		}
		.div-main {
		}
	}
}
</style>